/* istanbul ignore file */
import { connect } from 'react-redux'
import { userDataSelector } from '../../selectors/user'
import { tokenDataSelector } from '../../selectors/token'
import { requestUser } from '../../actions/user'
import RentalCarDetailContainer from './RentalCarDetailContainer'
import { ratesDataSelector } from 'rental-car-contract/js/selectors/rates'

import { rentalCarContractErrorSelector, rentalCarContractDataSelector, rentalCarContractIsLoadingSelector } from '../../selectors/rentalCarContract'
import { requestRentalCarContract } from 'rental-car-contract/js/actions/rentalCarContract'
import { navigateTo } from '../../actions/navigation'
function mapStateToProps (state) {
    return {
        rentalCarContract: rentalCarContractDataSelector(state),
        user: userDataSelector(state),
        isMutuaUser: ratesDataSelector(state).isMutuaUser,
        token: tokenDataSelector(state),
        isLoading: rentalCarContractIsLoadingSelector(state) || !userDataSelector(state),
        error: rentalCarContractErrorSelector(state),
    }
}

export default connect(mapStateToProps, {
    requestUser,
    navigateTo,
    request: requestRentalCarContract,
 })(RentalCarDetailContainer)
